export class IdGenerator {

    static POSSIBLE_CHARACTERS = "abcdefghijklmnopqrstuvwxyz0123456789";

    static generate(length:number): string{
        let id = "";
        for(let i = 0; i < length; i++) {
            id += IdGenerator.POSSIBLE_CHARACTERS.charAt(Math.floor(Math.random() * IdGenerator.POSSIBLE_CHARACTERS.length));
        }
        return id;
    }
}